<template>
  <div class="home">
    <p>開発者 ユーザ情報設定</p>
    <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
    <div v-for="link in links" :key="link.text" class="selectbox">
      <v-btn @click="move(link.to)" height="100" width="250">{{
        link.text
      }}</v-btn>
    </div>
    <hr />
  </div>
</template>

<script>
// 画面デザインや色などはCSSで調整
export default {
  name: "index",
  components: {},
  data: () => ({
    links: [{ to: "/developer/customer", text: "customerの所属変更・削除" }],
  }),
  methods: {
    move(link) {
      this.$router.push({
        path: link,
      });
    },
    back() {
      history.back();
    },
  },
};
</script>
<style>
.selectbox {
  float: left;
  margin: 4px;
}
</style>
